import { render } from "./Splitter.vue?vue&type=template&id=e4e803ae&scoped=true"
import script from "./Splitter.vue?vue&type=script&lang=js"
export * from "./Splitter.vue?vue&type=script&lang=js"

import "./Splitter.vue?vue&type=style&index=0&id=e4e803ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e803ae"]])

export default __exports__